export const msalConfig = {
    auth: {
      clientId: "661e37f1-1ecf-4580-ad3d-19b51700f70b",
      authority: "https://login.microsoftonline.com/71760229-9722-4c11-a810-8c55d35cd997",
      redirectUri: window.location.origin,
    },
    cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: false,
    }
  };
  
  export const loginRequest = {
    scopes: ["openid", "profile", "email", "User.Read"]
  };